<template>
	<div style="height: 100%;">
		<notifications></notifications>
		<pending />
		<div :class="{'nav-open': $sidebar.showSidebar}" style="height: 100%;">
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
	import Login from '@/pages/Login.vue'

	export default {
		components: {
			Login
		},
		data() {
			return {
				default: null
			}
		},
		created() {
			window.document.title = this.translate(this.locale.headTitle);
		}
	}
</script>
<style>
	.vdatetime {
		width: 100%;
	}
    .vdatetime-input {
        padding: 4px 12px !important;
		width: 100%;
		height: 38px;
		border-radius: 6px;
		border: 2px solid #EEE;
		font-family: "Open Sans", "Hanuman", sans-serif;
		color: #353690;
    }
	.text-primary {
        color: #353690;
    }
	.form-subsection-title {
		font-size: 15px !important;
		font-weight: bold;
		margin: 10px 0 15px 0;
	}
	.vs__dropdown-menu {
        margin-top: 3px !important;
        border: 2px solid #EEE !important;
        border-radius: 6px !important;
        padding: 0 !important;
    }
    .vs__dropdown-option {
        padding: 8px 20px !important;
    }
	.vs__actions {
		display: none !important;
	}
    .vs--open {
        border: 2px solid #353690 !important;
    }

    .vs__selected {
        font-family: "Open Sans", "Hanuman", sans-serif !important;
        color: #353690 !important;
    }
	.vs__dropdown-option--highlight, .vs__dropdown-option--selected {
		color: #FFF !important;
		background-color: #353690 !important;
	}

    .vs__dropdown-toggle {
        margin-top: 3px !important;
        margin-bottom: 24px !important;
		border: 0 !important;
    }

	.button-icon {
		margin-right: 5px;
	}
	@media (min-width: 992px) {
		.show-web {
			display: inline !important;
		}
		.show-mobile {
			display: none !important;
		}
	}
	@media (max-width: 991px) {
		.show-web {
			display: none !important;
		}
		.show-mobile {
			display: inline !important;
		}
	}
	.application-title {
		color: #353690;
	}
	.required {
		color: red;
	}
	
	.md-input::placeholder {
		font-size: 13px !important;
		color: #495057;
	}
	/* .md-card-header {
		display: none !important;
	} */
	.md-textarea {
		min-height: 80px !important;
	}

	.md-list-item-text {
		line-height: 48px !important;
		padding: 0px 18px !important;
		font-size: 14px;
	}

	.el-tabs__item.is-active {
		color: #199d48 !important;
	}

	.el-tabs__item:hover {
		color: #199d48 !important;
	}

	.el-tabs__active-bar {
		background-color: #199d48 !important;
	}

	.md-progress-bar-fill {
		background-color: #199d48 !important;
	}

	.md-progress-bar {
		background-color: #3c7ab736 !important;
	}

	.md-title {
		letter-spacing: 0 !important;
	}

	.green {
		background-color: #199d48;
		color: #FFF;
		border-radius: 5px;
		padding: 4px 8px;
	}

	.neutral {
		background-color: #c189ee;
		border-radius: 5px;
		padding: 4px 8px;
	}

	.late {
		background-color: #fab1a0;
		border-radius: 5px;
		padding: 4px 8px;
	}

	.error {
		background-color: #f35734;
		border-radius: 5px;
		padding: 4px 8px;
	}
	.gray {
		background-color: #bfbfbf;
		border-radius: 5px;
		padding: 4px 8px;
	}

	.warn {
		background-color: #f39c12;
		border-radius: 5px;
		padding: 4px 8px;
	}
	.blue {
		background-color: #80e6ff;
		border-radius: 5px;
		margin-top: 5px;
		padding: 4px 8px;
	}

	.return {
		background-color: #fd79a8;
		border-radius: 5px;
		padding: 4px 8px;
	}
	
	.md-list-item-text {
		font-family: "Open Sans", "Hanuman", sans-serif !important;
	}

	.vdatetime {
		width: 100%;
	}

	.error-text {
        color: red;
        text-align: right;
    }
    .price-container {
        border-radius: 6px;
        border: 2px solid #EEE;
        background-color: #EEE;
        height: 38px;
        display: flex;
        align-items: center;
        padding: 0 15px;
        color: #353690;
        margin: 5px 0;
    }
    .align-items-center {
        display: flex;
        justify-content: right;
        align-items: center;
    }
    .disabled-column {
        width: 100%;
        height: 100%;
        cursor: no-drop;
        background-color: #EEE;
    }
    .table-checkbox {
        margin: 0 !important;
    }
    .application-table-container {
        padding: 0 15px;
		margin: 12px 0;
        color: #353690; 
		width: 100%;
        overflow-x: scroll;
    }
    .application-table {
        width: 100%;
        border-collapse: collapse;
        border: 1px solid #353690;
        border-radius: 6px;
        height: 1px;
        min-width: 800px;
    }
    .application-tr {
        border: 1px solid #353690;
    }
    .td-padding {
        padding: 12px !important;
    }
    .application-td-head {
        border: 1px solid #353690;
        font-weight: bold;
        padding: 12px;
        text-align: center;
    }
    .application-td {
        border: 1px solid #353690;
        padding: 0;
    }
    .application-input-invisible {
        width: 100%;
        border: 0px;
        color: #353690;
        padding: 8px;
        height: 38px;
    }
    .td-no-padding {
        padding: 0 !important;
    }
    .td-bold {
        font-weight: bold;
    }
    .td-center {
        text-align: center;
    }
    .progress-container {
        width: 100%;
        margin-top: 5px;
        border-radius: 6px;
        position: relative;
        background-color: #353690;
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
        -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
    }

    .progress-full {
        width: 100%;
        background-color: #AAA;
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;
        height: 5px;
        position: absolute;
        bottom: 0;
    }

    .progress-complete {
        width: 20%;
        border-bottom-left-radius: 6px;
        background-color: #199d48;
        transition-duration: 500ms;
        height: 5px;
        position: absolute;
        bottom: 0;
    }

    .progress-label {
        display: flex;
    }

    .progress-label-text {
        width: 33.33%;
        padding: 12px 0 18px 0;
        cursor: pointer;
        text-align: center;
        border-right: 1px solid #FFF;
        font-weight: bold;
        font-size: 0.90rem;
        color: #FFF;
    }

    .progress-label-text:last-child {
        border-right: 0px;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue